var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from "react";
/**
 * Fonction permettant de récupérer les adresses.
 * @param group
 * @param record
 * @param fieldDef
 * @returns
 */
export function getDetailAddress(group, record, fieldDef) {
    var _a;
    var address = {
        group: group,
        street: "",
        street_2: "",
        street_3: "",
        street_4: "",
        city: "",
        state: "",
        postalcode: "",
        country: "",
    };
    for (var element in address) {
        if (element != "group" && element != undefined) {
            var elementFieldName = group + "_" + element;
            address[element] =
                (record === null || record === void 0 ? void 0 : record[elementFieldName]) ||
                    ((_a = fieldDef === null || fieldDef === void 0 ? void 0 : fieldDef[elementFieldName]) === null || _a === void 0 ? void 0 : _a.default) ||
                    "";
        }
    }
    return address;
}
/** <b>Composant en mode consultation/detail d'un champ de type address</b>*/
export default function AddressFieldDetail(_a) {
    var fieldName = _a.fieldName, record = _a.record, fieldMetadata = _a.fieldMetadata, fieldDef = _a.fieldDef;
    var group = fieldMetadata.group;
    var value = useMemo(function () {
        if (!record) {
            return;
        }
        return getDetailAddress(group, record, fieldDef);
    }, [fieldName, record, fieldDef]);
    return (_jsx("div", __assign({ className: "" }, { children: _jsxs("div", { children: [_jsx("div", { children: value.street }), _jsxs("div", { children: [value.city, " ", value.postalcode, " ", value.state] }), _jsx("div", { children: value.country })] }) })));
}
